import { getCustomerId } from './cookies';
import { getPortalSessionSnapshot } from './portalSession';

const CUSTOMER_NAME_KEYS = [
  'customerName',
  'customer_name',
  'custName',
  'companyName',
  'company_name',
  'clientName',
  'client_name',
] as const;

function readCustomerNameFromRecord(record: Record<string, unknown> | null | undefined): string {
  if (!record) {
    return '';
  }
  for (const key of CUSTOMER_NAME_KEYS) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
}

/**
 * Human-readable customer / tenant label for the app header.
 * Priority: portal projectsInfo name fields → VITE_CUSTOMER_NAME → customer id.
 */
export function getCustomerDisplayName(): string {
  const snapshot = getPortalSessionSnapshot();
  const fromProjectsInfo = readCustomerNameFromRecord(
    snapshot?.projectsInfo as Record<string, unknown> | null | undefined
  );
  if (fromProjectsInfo) {
    return fromProjectsInfo;
  }

  const env = (import.meta.env.VITE_CUSTOMER_NAME as string | undefined)?.trim();
  if (env) {
    return env;
  }

  return getCustomerId().trim();
}
